import { render, staticRenderFns } from "./AccumulationSetting.vue?vue&type=template&id=980688e8&"
import script from "./AccumulationSetting.vue?vue&type=script&lang=ts&"
export * from "./AccumulationSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports